// 发票管理页面路由
const FpList = () => import('@/views/fp/fpgl/index.vue');
const OaFpBatchimport = () => import('@/views/fp/importBath/oaFpBatchimport.vue');

export default [
  {
    path: '/fp/fpgl',
    name: 'fpgl',
    meta: {
      title: '我的发票',
      icon: 'dashboard',
      noCache: false,
      affix: true
    },
    component: FpList
  },
  {
    path: '/fp/importBath',
    name: 'fpImportBatch',
    meta: {
      title: '导入批次管理',
      icon: 'el-icon-upload2',
      path: '发票管理',
      noCache: true,
      affix: true
    },
    component: OaFpBatchimport
  }
];
